module.exports = __webpack_public_path__ + "img/social-distancing.617a09db.svg";